import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import EmbeddedAttachment from './EmbeddedAttachment';
import AppContext from '../../../context';
var EmbeddedAttachments = (_dec = connect(function (state) {
  return {
    lesson: state.lessonDetails.lesson,
    offline: state.online.offline
  };
}), injectIntl(_class = _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(EmbeddedAttachments, _React$Component);
  var _super = _createSuper(EmbeddedAttachments);
  function EmbeddedAttachments() {
    _classCallCheck(this, EmbeddedAttachments);
    return _super.apply(this, arguments);
  }
  _createClass(EmbeddedAttachments, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        lesson = _this$props.lesson,
        withVideo = _this$props.withVideo,
        offline = _this$props.offline;
      var attachments = _.filter(lesson.attachments, 'isEmbedded');
      if (!_.get(attachments, 'length') || offline) {
        return null;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, attachments.map(function (item, index) {
        return /*#__PURE__*/_jsx(EmbeddedAttachment, {
          item: item,
          withVideo: withVideo,
          isLast: index === attachments.length - 1
        }, item._id);
      }));
    }
  }]);
  return EmbeddedAttachments;
}(React.Component), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class);
export { EmbeddedAttachments as default };